/**
 * Stage name constants
 */
export const STAGE_NAMES = {
  SING_AND_INSTRUMENT: 'Sing and Instrument',
  SING_VOICE_ONLY: 'Sing Voice only',
  SING_VOICE_ONLY_REPEAT: 'Sing Voice only (repeat)',
} as const;

/**
 * Check if stage is a custom song singing stage
 */
export type StageName = typeof STAGE_NAMES[keyof typeof STAGE_NAMES];

